/* Compte a rebours de l'operation : un seul minuteur pour toutes les instances. */
const MINUTE = 60;
const HEURE = 3600;
const JOUR = 86400;

class HbCountdown extends HTMLElement {
  connectedCallback() {
    this.fin = Date.parse(this.getAttribute('deadline') || '');
    this.valeur = this.querySelector('[data-hb-countdown-value]');
    if (Number.isNaN(this.fin) || !this.valeur) return;
    HbCountdown.registre.add(this);
    this.peindre();
    HbCountdown.demarrer();
  }

  disconnectedCallback() {
    HbCountdown.registre.delete(this);
  }

  peindre() {
    let reste = Math.floor((this.fin - Date.now()) / 1000);
    if (reste <= 0) {
      this.expirer();
      return;
    }
    const j = Math.floor(reste / JOUR);
    reste -= j * JOUR;
    const h = Math.floor(reste / HEURE);
    reste -= h * HEURE;
    const m = Math.floor(reste / MINUTE);
    const s = reste - m * MINUTE;
    const deux = (n) => String(n).padStart(2, '0');
    this.valeur.textContent = j > 0
      ? `${j} j ${deux(h)} h ${deux(m)} min`
      : `${deux(h)} h ${deux(m)} min ${deux(s)} s`;
  }

  /* Passe la date de fin : on retire tout l'encart plutot que d'afficher une promo terminee. */
  expirer() {
    HbCountdown.registre.delete(this);
    const hote = this.closest('[data-hb-promo]') || this;
    hote.hidden = true;
  }
}

HbCountdown.registre = new Set();
HbCountdown.minuteur = null;
HbCountdown.demarrer = () => {
  if (HbCountdown.minuteur) return;
  HbCountdown.minuteur = setInterval(() => {
    HbCountdown.registre.forEach((el) => el.peindre());
    if (HbCountdown.registre.size === 0) {
      clearInterval(HbCountdown.minuteur);
      HbCountdown.minuteur = null;
    }
  }, 1000);
};

if (!customElements.get('hb-countdown')) {
  customElements.define('hb-countdown', HbCountdown);
}
